 const checkUserRole = () => {
        const storedData = localStorage.getItem("userDetails");
        if (storedData) {
            try {
                const parsedData = JSON.parse(storedData);
                const roleName = parsedData?.[0]?.roleName;
                if (roleName !== "ADMIN" && roleName !== "TOOLADMIN") {
                   return true;
                }else{
                    return false;
                }
            } catch (err) {
                console.error("Error reading role from localStorage", err);
            }
        }
    };

export default checkUserRole;